module.exports = __webpack_public_path__ + "static/media/runway editoral .480a2443.jpg";